/* KK cart drawer — Kking's Jewellery (markup: sections/kk-cart-drawer.liquid; ported from the Pashupati drawer)
   Opens from the header cart icon and after Add to Cart. Every cart change goes through
   Shopify's cart API with the `sections` option, so the drawer's HTML comes back already
   worked out by Liquid and is swapped in here.
   Checkout is never touched: Fastrr's script fills the drawer's .shiprocket-headless
   (data-type="mini-cart") slot with its own Buy Now button and handles the click itself.
   Nothing here calls Fastrr, and the slot sits outside the parts that get swapped, so
   Fastrr's button stays mounted. */
(function () {
  'use strict';

  var root, panel, sectionId, lastFocus = null, noteTimer = null, busy = false;
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, el) { return (el || root).querySelector(sel); }

  /* ---------- open / close ---------- */
  function open() {
    if (!root) return;
    if (pop.active) return;            /* the add-to-cart celebration opens it when it ends */
    if (!root.classList.contains('is-open')) {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('aij-cd-lock');
      document.body.classList.add('aij-cd-open');
      setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 60);
    }
    if (root.dataset.confetti === 'true' && !root.classList.contains('is-empty')) confetti();
    startTimer(false);
  }

  function close() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aij-cd-lock');
    document.body.classList.remove('aij-cd-open');
    clearInterval(timerId); timerId = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- render the HTML that came back from the cart API ---------- */
  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('KkCart');
    if (!fresh) return;
    var keepScroll = $('[data-aij-cd-body]').scrollTop;
    var tab = $('[data-aij-cd-tab][aria-selected="true"]');
    tab = tab && tab.getAttribute('data-aij-cd-tab');
    ['[data-aij-cd-body]', '[data-aij-cd-count]', '[data-aij-cd-foot]'].forEach(function (sel) {
      var a = $(sel), b = fresh.querySelector(sel);
      if (a && b) a.innerHTML = b.innerHTML;
    });
    root.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    if (fresh.hasAttribute('data-total')) root.dataset.total = fresh.getAttribute('data-total');
    if (tab) showTab(tab);
    tick();
    $('[data-aij-cd-body]').scrollTop = keepScroll;
    headerCount(parseInt(fresh.getAttribute('data-count'), 10));
  }

  /* the header's cart badge */
  /* Horizon's header bubble listens for its own 'cart:update' event */
  var lastCount = null;
  function headerCount(n) {
    if (isNaN(n) || n === lastCount) return;
    lastCount = n;
    /* Horizon 4: <cart-icon> only listens to Shopify's standard cart events, so set it directly */
    document.querySelectorAll('cart-icon').forEach(function (el) {
      if (typeof el.renderCartBubble === 'function') { try { el.renderCartBubble(n); } catch (e) {} }
    });
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = { resource: { item_count: n }, sourceId: 'kk-cd', data: { source: 'kk-cd', itemCount: n } };
    document.dispatchEvent(ev);
  }

  function notice(msg) {
    var n = $('[data-aij-cd-notice]');
    if (!n) return;
    n.textContent = msg || '';
    n.hidden = !msg;
    if (msg) setTimeout(function () { if (n.textContent === msg) n.hidden = true; }, 6000);
  }

  function setBusy(on) {
    busy = on;
    root.classList.toggle('is-busy', on);
  }

  /* ---------- order timer: one deadline per browser session, restarted on every add to the
     cart and whenever the cart is opened after it ran out. It is display only: running out
     changes nothing in the cart, its prices or discounts, or Fastrr's checkout. ---------- */
  var TKEY = 'kk_cd_deadline', timerId = null;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function secs() { return parseInt(root.dataset.timer, 10) || 0; }
  function deadline(reset) {
    var d = 0;
    try { d = parseInt(sessionStorage.getItem(TKEY), 10) || 0; } catch (e) {}
    if (reset || !d) {
      d = Date.now() + secs() * 1000;
      try { sessionStorage.setItem(TKEY, String(d)); } catch (e) {}
    }
    return d;
  }
  function tick() {
    var total = secs(), clock = $('[data-aij-cd-clock]');
    if (!total || !clock) return;
    var left = Math.max(0, Math.round((deadline(false) - Date.now()) / 1000));
    clock.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    var bar = $('[data-aij-cd-timer-bar]');
    if (bar) bar.style.width = (left / total * 100) + '%';
    root.classList.toggle('is-timeup', left === 0);
  }
  function startTimer(reset) {
    if (!secs() || root.classList.contains('is-empty')) return;
    var d = deadline(false);
    deadline(reset || d <= Date.now());
    tick();
    if (!timerId) timerId = setInterval(function () { if (root.classList.contains('is-open')) tick(); }, 1000);
  }

  function showTab(n) {
    root.querySelectorAll('[data-aij-cd-tab]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-aij-cd-tab') === String(n) ? 'true' : 'false'); });
    root.querySelectorAll('[data-aij-cd-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-aij-cd-panel') !== String(n); });
  }

  /* ---------- cart API ---------- */
  function post(path, body) {
    var isForm = typeof FormData !== 'undefined' && body instanceof FormData;
    if (isForm) {
      body.append('sections', sectionId);
      body.append('sections_url', location.pathname);
    } else {
      body.sections = [sectionId];
      body.sections_url = location.pathname;
    }
    return fetch(ROOT_URL + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: isForm ? { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
                      : { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (txt) {
        var data;
        try { data = JSON.parse(txt); } catch (e) {
          var soft = new Error('We could not update your cart. Please try again.');
          soft.soft = true;            /* not a cart answer (network or security check page) */
          throw soft;
        }
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        return data;
      });
    });
  }

  /* resolves to null when it worked, or to the error */
  function run(path, body, after) {
    if (busy) return Promise.resolve(null);
    setBusy(true);
    notice('');
    return post(path, body)
      .then(function (data) {
        render(data.sections && data.sections[sectionId]);
        if (after) after(data);
        document.dispatchEvent(new CustomEvent('aij:cart:changed', { detail: data }));
        return null;
      })
      .catch(function (err) { notice(err.message); return err; })
      .then(function (err) { setBusy(false); return err; });
  }

  function change(body) { return run('cart/change.js', body); }
  function add(items, after) { return run('cart/add.js', { items: items }, after); }

  /* fresh copy without changing anything (on open, and when coming back to a page) */
  function refresh() {
    if (!sectionId) return Promise.resolve();
    return fetch(location.pathname + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d[sectionId]) render(d[sectionId]); })
      .catch(function () {});
  }

  /* ---------- clicks inside the drawer ---------- */
  function onClick(e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-aij-cd-close]'))) { e.preventDefault(); close(); return; }
    if ((el = t.closest('[data-aij-cd-qty]'))) {
      var line = el.closest('[data-line]');
      if (line) change({ line: parseInt(line.dataset.line, 10), quantity: Math.max(0, parseInt(el.getAttribute('data-aij-cd-qty'), 10) || 0) });
      return;
    }
    if ((el = t.closest('[data-aij-cd-remove]'))) {
      var c = el.closest('[data-line]').querySelector('.aij-cd__confirm');
      if (c) { c.hidden = false; var b = c.querySelector('[data-aij-cd-keep]'); if (b) b.focus(); }
      return;
    }
    if ((el = t.closest('[data-aij-cd-keep]'))) { el.closest('.aij-cd__confirm').hidden = true; return; }
    if ((el = t.closest('[data-aij-cd-add]'))) {
      var id = el.getAttribute('data-aij-cd-add');
      if (id === 'select') { var sel = el.parentNode.querySelector('select'); id = sel && sel.value; }
      if (id) {
        el.classList.add('is-adding');
        add([{ id: parseInt(id, 10), quantity: 1 }], function () { startTimer(true); }).then(function () { el.classList.remove('is-adding'); });
      }
      return;
    }
    if ((el = t.closest('[data-aij-cd-tab]'))) { showTab(el.getAttribute('data-aij-cd-tab')); return; }
    if ((el = t.closest('[data-aij-cd-copy]'))) {
      var code = el.getAttribute('data-aij-cd-copy');
      var done = function () { el.textContent = 'Copied ✓'; el.classList.add('is-done'); setTimeout(function () { el.textContent = 'Copy'; el.classList.remove('is-done'); }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
      return;
    }
    if ((el = t.closest('[data-aij-cd-tobill]'))) {
      e.preventDefault();
      var bill = document.getElementById('KkCartBill');
      if (bill) bill.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    if ((el = t.closest('[data-aij-cd-native]'))) { location.href = ROOT_URL + 'checkout'; }
  }

  function onChange(e) {
    var t = e.target;
    if (t.matches('[data-aij-cd-tick]')) {
      var vid = parseInt(t.getAttribute('data-aij-cd-tick'), 10);
      if (t.checked) add([{ id: vid, quantity: 1 }], function () { startTimer(true); });
      else change({ id: String(vid), quantity: 0 });
    }
  }

  function onInput(e) {
    if (!e.target.matches('[data-aij-cd-note]')) return;
    var val = e.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(ROOT_URL + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: val })
      }).catch(function () {});
    }, 600);
  }

  /* keep keyboard focus inside the open drawer */
  function onKey(e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      var c = root.querySelector('.aij-cd__confirm:not([hidden])');
      if (c) c.hidden = true; else close();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,summary,[tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- open from anywhere ---------- */
  function isCartLink(a) {
    if (!a || !a.getAttribute('href')) return false;
    try {
      var u = new URL(a.href, location.href);
      return u.origin === location.origin && /\/cart\/?$/.test(u.pathname) && !u.search;
    } catch (e) { return false; }
  }

  function onDocClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a || !isCartLink(a) || root.contains(a)) return;
    if (/\/cart\/?$/.test(location.pathname)) return;   /* already on the cart page */
    e.preventDefault();
    open();
    refresh();
  }

  /* Add to Cart on product forms: add over AJAX and open the drawer instead of going to /cart.
     Only real submits reach here; Fastrr's Buy Now is a type="button" with its own handler. */
  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?$/.test(action.split('?')[0])) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('aij-adding'); btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    /* celebration first (the drawer opens after it); without it, open straight away and the
       loading line shows until the item lands */
    if (!popStart()) open();
    run('cart/add.js', fd, function () {
      if (pop.active) popResult(parseInt(root.dataset.total, 10));
      else if (root.dataset.confetti === 'true') confetti();
      startTimer(true);
    })
      .then(function (err) {
        if (btn) { btn.classList.remove('aij-adding'); btn.removeAttribute('aria-busy'); }
        if (err) popCancel();
        if (err && err.soft) { form.submit(); return; }   /* the plain form post still adds it */
        if (err) open();                                   /* e.g. sold out: show the message */
      });
  }

  /* Fastrr shows its button only to shoppers in India (layout/theme.liquid hides it elsewhere);
     everyone else gets a plain button to Shopify's checkout */
  function nativeFallback() {
    var slot = $('.shiprocket-headless'), btn = $('[data-aij-cd-native]');
    if (!slot || !btn) return;
    btn.hidden = getComputedStyle(slot).display !== 'none';
  }

  /* ---------- confetti: three soft gold bursts over the drawer ---------- */
  var lastBurst = 0;
  function confetti() {
    if (reduce) return;
    var now = Date.now();
    if (now - lastBurst < 1500) return;
    lastBurst = now;
    setTimeout(function () {
      var box = panel.getBoundingClientRect();
      if (!box || box.width < 50) box = { left: 0, width: window.innerWidth, top: 0 };
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var cv = document.createElement('canvas');
      cv.className = 'aij-confetti';
      cv.setAttribute('aria-hidden', 'true');
      cv.width = window.innerWidth * dpr; cv.height = window.innerHeight * dpr;
      document.body.appendChild(cv);
      var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
      var colours = ['#B8893A', '#E6BF6A', '#F3DCA0', '#5C0A18', '#FBF1DE', '#D9B262'];
      var bits = [];
      var burst = function (cx) {
        for (var i = 0; i < 46; i++) {
          var a = -Math.PI / 2 + (Math.random() - 0.5) * 1.9, v = 5 + Math.random() * 7;
          bits.push({ x: cx, y: box.top + 80, vx: Math.cos(a) * v, vy: Math.sin(a) * v,
            w: 5 + Math.random() * 5, h: 3 + Math.random() * 4, r: Math.random() * 6, vr: (Math.random() - 0.5) * 0.3,
            c: colours[(Math.random() * colours.length) | 0], round: Math.random() < 0.3 });
        }
      };
      burst(box.left + box.width / 2);
      setTimeout(function () { burst(box.left + box.width * 0.25); }, 180);
      setTimeout(function () { burst(box.left + box.width * 0.75); }, 360);
      var start = performance.now();
      (function frame(t) {
        var age = t - start;
        ctx.clearRect(0, 0, cv.width, cv.height);
        ctx.globalAlpha = age > 1700 ? Math.max(0, 1 - (age - 1700) / 700) : 1;
        bits.forEach(function (b) {
          b.vy += 0.22; b.vx *= 0.985; b.x += b.vx; b.y += b.vy; b.r += b.vr;
          ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(b.r); ctx.fillStyle = b.c;
          if (b.round) { ctx.beginPath(); ctx.arc(0, 0, b.h / 1.6, 0, 6.283); ctx.fill(); }
          else ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h * Math.abs(Math.cos(b.r * 2)) + 1);
          ctx.restore();
        });
        if (age < 2400) requestAnimationFrame(frame); else cv.remove();
      })(start);
    }, 320);
  }

  /* ---------- Add to cart celebration: Diwali fireworks + "Free gift added" card for a moment,
     then the drawer opens. Every Add to cart (product page form and the quick-add buttons on cards)
     goes through popStart(); open() waits while it is showing. The message is picked from the cart
     total once the cart answers, so it only says "free gift" when the spend is really reached. ---------- */
  var pop = { el: null, active: false, done: false, t0: 0, timers: [], raf: 0 };

  function popClear() { pop.timers.forEach(clearTimeout); pop.timers = []; cancelAnimationFrame(pop.raf); }
  function later(fn, ms) { pop.timers.push(setTimeout(fn, ms)); }

  function popStart() {
    if (pop.active) return true;
    pop.el = pop.el || document.querySelector('[data-kk-pop]');
    if (!pop.el || !root || root.classList.contains('is-open')) return false;
    var el = pop.el, eb = el.querySelector('[data-kk-pop-eyebrow]');
    if (!el.dataset.wait) el.dataset.wait = eb.textContent;
    eb.textContent = el.dataset.wait;
    el.querySelector('[data-kk-pop-title]').textContent = '';
    el.querySelector('[data-kk-pop-text]').textContent = '';
    el.classList.remove('is-on', 'is-done', 'is-out', 'is-gift');
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-on');
    pop.active = true; pop.done = false; pop.t0 = Date.now();
    if (!el.dataset.bound) { el.dataset.bound = '1'; el.addEventListener('click', function () { popEnd(); }); }
    fireworks(el.querySelector('.kk-pop__sky'));
    later(popEnd, 4500);                       /* the cart never answered: carry on to the drawer */
    return true;
  }

  function popResult(total) {
    if (!pop.active || pop.done) return;
    pop.done = true;
    var el = pop.el, d = el.dataset;
    var min = parseInt(root.dataset.giftMin, 10) || 0;
    var t = isNaN(total) ? (parseInt(root.dataset.total, 10) || 0) : total;
    var reached = min > 0 && t >= min;
    var amount = '₹' + Math.ceil(Math.max(0, min - t) / 100).toLocaleString('en-IN');
    el.querySelector('[data-kk-pop-eyebrow]').textContent = reached ? d.eyebrow : d.lowEyebrow;
    el.querySelector('[data-kk-pop-title]').textContent = reached ? d.title : (min > 0 ? d.lowTitle : 'Added to your bag!');
    el.querySelector('[data-kk-pop-text]').textContent = reached ? d.text : (min > 0 ? (d.lowText || '').replace('[amount]', amount) : '');
    el.classList.toggle('is-gift', reached);
    var hold = parseInt(d.ms, 10) || 1500;
    el.style.setProperty('--kk-pop-ms', hold + 'ms');
    later(function () { el.classList.add('is-done'); later(popEnd, hold); }, Math.max(0, 380 - (Date.now() - pop.t0)));
  }

  /* fade out and open the drawer */
  function popEnd() {
    if (!pop.active) return;
    popClear();
    pop.active = false;
    lastBurst = Date.now();                     /* the fireworks were the celebration: no confetti on top */
    var el = pop.el;
    el.classList.add('is-out');
    setTimeout(function () { if (!pop.active) { el.hidden = true; el.classList.remove('is-on', 'is-done', 'is-out'); } }, 280);
    open();
  }

  /* the add failed: close quietly, no drawer */
  function popCancel() {
    if (!pop.active) return;
    popClear();
    pop.active = false;
    pop.el.hidden = true;
    pop.el.classList.remove('is-on', 'is-done', 'is-out');
  }

  function fireworks(cv) {
    if (reduce || !cv || !cv.getContext) return;
    var W = window.innerWidth, H = window.innerHeight, dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = W * dpr; cv.height = H * dpr;
    var ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    var cols = ['#FFD36B', '#F4A62A', '#FFF3C4', '#FF7A3D', '#E2B95E', '#FF9EC0', '#FFFFFF'];
    var rockets = [], sparks = [], small = W < 750;
    var n = small ? 48 : 64;
    var boom = function (x, y, count, k) {
      var a1 = cols[k % cols.length], a2 = cols[(k + 2) % cols.length];
      for (var i = 0; i < count; i++) {
        var a = Math.PI * 2 * i / count + Math.random() * 0.25, v = (small ? 1.8 : 2.4) + Math.random() * (small ? 2.8 : 3.6);
        sparks.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: 1, fade: 0.011 + Math.random() * 0.012,
          c: Math.random() < 0.5 ? a1 : a2, r: 1.3 + Math.random() * 1.7, tw: Math.random() < 0.35 });
      }
    };
    var launch = function (fx, fy, k) {
      var ty = H * fy;
      rockets.push({ x: W * fx, y: H + 8, vy: -(H + 8 - ty) / 24, ty: ty, k: k });
    };
    boom(W / 2, H / 2 - 30, n + 16, 0);         /* instant burst behind the card */
    [[0.18, 0.26, 1, 90], [0.82, 0.22, 3, 230], [0.32, 0.14, 5, 400], [0.7, 0.32, 2, 560],
     [0.5, 0.1, 4, 760], [0.12, 0.42, 6, 980], [0.88, 0.4, 0, 1150]].forEach(function (p) {
      later(function () { launch(p[0], p[1], p[2]); }, p[3]);
    });
    (function frame() {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,0.3)';
      ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = rockets.length - 1; i >= 0; i--) {
        var r = rockets[i];
        r.y += r.vy;
        ctx.fillStyle = '#FFE7A8';
        ctx.beginPath(); ctx.arc(r.x, r.y, 2.2, 0, 6.283); ctx.fill();
        sparks.push({ x: r.x + (Math.random() - 0.5) * 2, y: r.y + 4, vx: 0, vy: 0.6, life: 0.6, fade: 0.05, c: '#F4A62A', r: 1.2 });
        if (r.y <= r.ty) { boom(r.x, r.y, n, r.k); rockets.splice(i, 1); }
      }
      for (var j = sparks.length - 1; j >= 0; j--) {
        var s = sparks[j];
        s.vx *= 0.985; s.vy = s.vy * 0.985 + 0.045; s.x += s.vx; s.y += s.vy; s.life -= s.fade;
        if (s.life <= 0) { sparks.splice(j, 1); continue; }
        if (s.tw && Math.random() < 0.4) continue;
        ctx.globalAlpha = Math.min(1, s.life * 1.4);
        ctx.fillStyle = s.c;
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r * (0.5 + s.life / 2), 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (pop.active) pop.raf = requestAnimationFrame(frame);
      else ctx.clearRect(0, 0, W, H);
    })();
  }

  function init() {
    root = document.getElementById('KkCart');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    panel = root.querySelector('.aij-cd__panel');
    sectionId = root.getAttribute('data-section');
    if (root.dataset.shake === 'true') root.classList.add('aij-cd--shake');

    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    root.addEventListener('input', onInput);
    document.addEventListener('keydown', onKey);
    document.addEventListener('click', onDocClick, true);
    /* on window, not document: Horizon's component.js catches every submit on document (capture)
       and registers first, so on document both handlers ran and each added the item (qty 2) */
    window.addEventListener('submit', onSubmit, true);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    nativeFallback();
    setTimeout(nativeFallback, 1500);

    window.KKDrawer = { open: open, close: close, refresh: refresh, add: add, celebrate: popStart, cancelCelebrate: popCancel };
    lastCount = parseInt(root.getAttribute('data-count'), 10);

    /* Take over Horizon's cart drawer: its header cart button, its auto-open after adds and our
       own quick-add buttons all call open()/showDialog() on cart-drawer-component. */
    var celebrate = function () { if (root.dataset.confetti === 'true' && !root.classList.contains('is-empty')) confetti(); };
    var openFresh = function () { open(); refresh().then(celebrate); };
    customElements.whenDefined('cart-drawer-component').then(function () {
      var P = customElements.get('cart-drawer-component').prototype;
      P.open = openFresh;
      P.showDialog = openFresh;
    });

    /* Horizon 4: the cart drawer is a generic <theme-drawer id="cart-drawer">. The header cart
       button calls its toggle(), the add-to-cart auto-open calls open(), and its restore script
       re-opens it from sessionStorage when the shopper comes back (e.g. from Fastrr's checkout).
       Send all of those to this drawer instead, and close Horizon's if it was restored. */
    try {
      var saved = (sessionStorage.getItem('theme-drawer-open') || '').split(',').filter(function (id) { return id && id !== 'cart-drawer'; });
      sessionStorage.setItem('theme-drawer-open', saved.join(','));
    } catch (e) {}
    customElements.whenDefined('theme-drawer').then(function () {
      var TD = customElements.get('theme-drawer').prototype;
      ['open', 'toggle'].forEach(function (m) {
        var orig = TD[m];
        if (typeof orig !== 'function') return;
        TD[m] = function () {
          if (this.id !== 'cart-drawer') return orig.apply(this, arguments);
          if (m === 'toggle' && root.classList.contains('is-open')) close(); else openFresh();
        };
      });
      var hd = document.getElementById('cart-drawer');
      if (hd && hd.hasAttribute('open') && typeof TD.close === 'function') {
        try { TD.close.call(hd); } catch (e) {}
        document.querySelector('.page-wrapper--drawer-open') && document.querySelector('.page-wrapper--drawer-open').classList.remove('page-wrapper--drawer-open');
      }
    });

    /* Anything else that changes the cart (quick add on cards, reels, recently viewed) */
    document.addEventListener('cart:update', function (e) {
      var src = e.detail && e.detail.data && e.detail.data.source;
      if (src === 'kk-cd') return;
      var res = e.detail && e.detail.resource;
      if (pop.active && res && res.total_price != null) popResult(res.total_price);
      refresh().then(function () { startTimer(true); if (root.classList.contains('is-open')) celebrate(); });
    });
    if (/[?&]cart=open\b/.test(location.search)) open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
